<template>
  <div>
    Redirecting to Spotify...
  </div>
</template>

<script>
export default {
  created() {
    let artistID = this.$route.params.artistID;
    let spotifyURL = `https://open.spotify.com/artist/${artistID}`;
    window.location.href = spotifyURL;
  }
}
</script>